module.exports = __webpack_public_path__ + "img/business-bg.24714f91.png";